// import axios from "@/axios"; 
import axiosSync from "@/axiosSync";
import axios from "@/axios";

export function usePortInfoApi() {
  async function getOnuInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=portinfoanddb&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getPonPortInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=portinfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getOltInfo(olt_id) {
    const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=oltinfo&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function graphRefresh(olt_id) {
    const response = await axios.put(`/olt-port-sync/${olt_id}/update/`);
    return response.data;
  }



  return {
    getOnuInfo,
    getPonPortInfo,
    getOltInfo,
    graphRefresh,
  };
}
